import { render, staticRenderFns } from "./TheLoader.vue?vue&type=template&id=4ba42d42&scoped=true&"
import script from "./TheLoader.vue?vue&type=script&lang=js&"
export * from "./TheLoader.vue?vue&type=script&lang=js&"
import style0 from "./TheLoader.vue?vue&type=style&index=0&id=4ba42d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba42d42",
  null
  
)

export default component.exports